import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

// CSS Imports
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// Images Import
// import img1 from '../assets/img/auditionBanner1.jpeg';

import img1 from '../assets/img/auditionBanner1.jpeg';
import img2 from '../assets/img/auditionBanner2.jpeg';
import img3 from '../assets/img/auditionBanner3.jpeg';

import mob1 from '../assets/img/mobBanner1.jpeg';
import mob2 from '../assets/img/mobBanner2.jpeg';
import mob3 from '../assets/img/mobBanner3.png';

const BannerSlider = () => {
  const banners = [img1, img2, img3];
  const mobileBanners = [mob1, mob2, mob3]; // Define mobile banners

  const allBanners = [...banners, ...banners, ...banners];
  const allMobileBanners = [...mobileBanners, ...mobileBanners, ...mobileBanners];

  // Conditionally select the image based on screen size
  const getImageSource = (index) => {
    if (window.innerWidth <= 768) {
      return allMobileBanners[index % mobileBanners.length]; // Use corresponding mobile images
    } else {
      return allBanners[index % banners.length];
    }
  };

  return (
    <div className="slider-wrapper">
      <style>{`
        .slider-wrapper {
          width: 100%;
          padding: 20px 0;
          overflow: hidden;
        }

        .swiper {
          width: 100%;
          overflow: visible !important;
          padding-bottom: 10px !important;
        }

        .swiper-slide {
          transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
          opacity: 0.5;
          transform: scale(0.9);
          display: flex;
          justify-content: center;
        }

        /* Active Slide (Main image with 80% width) */
        .swiper-slide-active {
          opacity: 1;
          transform: scale(1.05);
          z-index: 10;
        }

        .banner-img {
          width: 100%;
          height: 520px;
          border-radius: 20px;
          display: block;
          object-fit: cover;
          box-shadow: 0 15px 45px rgba(0,0,0,0.7);
        }

        /* Red Dots styling */
        .swiper-pagination-bullet { background: #fff !important; opacity: 0.4; }
        .swiper-pagination-bullet-active {
          background: #ff0000 !important;
          width: 28px;
          border-radius: 5px;
          opacity: 1;
        }

        @media (max-width: 768px) {
          .banner-img {
            height: 150px;
            border-radius: 12px;
          }
          .swiper-slide { transform: scale(0.95); }
          .slider-wrapper {
          width: 100%;
          padding-top: 6px;
          padding-bottom: 0;
          overflow: hidden;
        }
        }
      `}</style>

      <Swiper
        modules={[Pagination, Autoplay, Navigation]}
        slidesPerView={1.25}
        centeredSlides={true}
        spaceBetween={30}
        loop={true}
        speed={1100}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        breakpoints={{
          320: { slidesPerView: 1.1, spaceBetween: 10 },
          1024: { slidesPerView: 1.25, spaceBetween: 30 }
        }}
      >
        {allBanners.map((_, index) => ( // Iterate based on number of banners
          <SwiperSlide key={index}>
            <img src={getImageSource(index)} alt={`Banner ${index}`} className="banner-img" />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BannerSlider;